/* eslint-disable react-hooks/exhaustive-deps */
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Layout } from '@orientaction/components';
import { FC, useCallback, useEffect, useState } from 'react';
import StatsTable from '../../components/StatsTable';
import { apiServiceNative } from '../../utils/fetchNative';

const ROWS_PER_PAGE = 10;

const AdminLeads: FC = () => {
  const classes = useStyles();
  const [leads, setLeads] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  const fetchLeads = useCallback(async (currentPage: number) => {
    setLoading(true);
    try {
      const start = currentPage * ROWS_PER_PAGE;
      const response = await apiServiceNative.get(
        `/api/leads?populate=test&pagination[start]=${start}&pagination[limit]=${ROWS_PER_PAGE}&sort=createdAt:desc`,
      );
      const data = response?.data || response;

      if (Array.isArray(data)) {
        setLeads(data);
        setTotal(response?.meta?.pagination?.total || data.length);
      } else if (data?.data) {
        setLeads(data.data);
        setTotal(data?.meta?.pagination?.total || data.data.length);
      } else {
        setLeads([]);
        setTotal(0);
      }
    } catch {
      setLeads([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLeads(page);
  }, [page]);

  const columns = [
    {
      id: 'email',
      label: 'EMAILS',
      minWidth: 250,
    },
    {
      id: 'test',
      label: 'TESTS',
      minWidth: 250,
    },
    {
      id: 'date',
      label: 'DATES / HEURES',
      minWidth: 200,
    },
  ];

  const transformedData = leads.map((lead: any) => {
    const attrs = lead?.attributes || lead;
    const createdAt = attrs?.createdAt ? new Date(attrs.createdAt) : null;
    const dateStr = createdAt
      ? `${createdAt.toLocaleDateString('fr-FR')} - ${createdAt
          .toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
          .replace(':', 'h')}`
      : '-';

    return {
      id: lead?.id,
      email: attrs?.email || '-',
      test: attrs?.test?.data?.attributes?.title || attrs?.test?.title || attrs?.testTitle || '-',
      date: dateStr,
    };
  });

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  return (
    <Layout isaddBackground={true}>
      <div className={classes.container}>
        <Typography className={classes.title}>
          Leads &ndash; Tests partag&eacute;s
        </Typography>

        {loading && page === 0 ? (
          <div className={classes.loadingContainer}>
            <CircularProgress style={{ color: '#000A8C' }} />
          </div>
        ) : (
          <StatsTable
            columns={columns}
            data={transformedData}
            loading={loading && page > 0}
            bgColor="#23296F"
            pagination={{
              count: total,
              onChangePage: handleChangePage,
              page,
              rowsPerPage: ROWS_PER_PAGE,
            }}
          />
        )}
      </div>
    </Layout>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    margin: '0 auto',
    width: '94%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: 24,
    color: '#000A8C',
    marginBottom: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 300,
  },
}));

export default AdminLeads;
